export const CASETAFEL_FORM_OPTIONS_RESOURCE = {
  key: 'CASETAFEL_FORM_OPTIONS_RESOURCE',
  table: {
    defaultSort: '',
    dataLocation: '_embedded.resourceList',
    dataTransform: (data) => data?.map((form) => ({ value: form.identifier, label: form.name, meta: form }))
  },
  api: {
    get: () => {
      throw new Error('replace api.get with dossierType param for CASETAFEL_FORM_OPTIONS_RESOURCE');
    }
  }
};
